import { toast } from 'react-toastify';

export const toastMessage = (message: string, type: 'success' | 'error' | 'warning' | 'info' = 'info') => {
  // Log to console for debugging
  console.log(`[TOAST ${type.toUpperCase()}] ${message}`, 'Calling toast function...');

  try {
    // Show toast notification
    switch (type) {
      case 'success':
        toast.success(message);
        break;
      case 'error':
        toast.error(message);
        break;
      case 'warning':
        toast.warning(message);
        break;
      case 'info':
      default:
        toast.info(message);
        break;
    }
    console.log('Toast called successfully');
  } catch (error) {
    console.error('Error calling toast:', error);
  }
};